export const MODULE_NAME = 'onboarding';
export const ONBOARDING_ROUTE = `/${MODULE_NAME}`;
export const ONBOARDING_JOURNEY_ROUTE = `/${MODULE_NAME}/onboarding-journey/new`;
